/* eslint-disable import/no-anonymous-default-export */


export default ({
    children, cl
}
) => {
    return (
        <div className={"scrollbar-hide relative  md:h-screen  py-8 md:py-0  px-8  md:px-20 lg:px-32  gap-16  lg:gap-32 xl:gap-64snap-center flex justify-center items-center overflow-y-auto " + cl}>
            {
                children
            }
        </div>
    );
};


